import React, { useEffect, useMemo, useState } from "react";
import { useAuthContext } from "../../shered/contexts";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe } from "../../shered/components";
import { VForm, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import {
    Box, Button, Card, CardActionArea, CardContent, Icon,
    Paper, Tooltip, Typography,
    IconButton,
    Tab,
    Tabs,
    tabsClasses,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    useTheme,
    Autocomplete,
    CircularProgress

} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { FranquiaService, IDadosDispensaHistorico, IDetalheFranquia, ILstDrop, ILstDropAtivosProposta } from "../../shered/services/api/franquia/FranquiaService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { Loading } from "../../shered/components/loading/Loading";
import { TDropOptions, UtilidadeService, lstTiposAtivos } from "../../shered/services/api/utilidades/UtilidadesService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { IDadosPropostaTroca, IDadosPropostas, IDadosSavePropostas, PropostaService } from "../../shered/services/api/propostas/PropostaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { IDadosRetornoJogador, IListagemJogador, JogadorService } from "../../shered/services/api/jogador/JogadorService";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
                // value === index && (
                 <Box sx={{ p: UtilidadeService.isMobile() ? 0 : 1 }}>
                    <Grid>{children}</Grid>
                </Box>
                //)
            }
        </div>
         : ""}
        </>
    );
}

function a11yProps(index: number) {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}

                thousandSeparator={'.'}
                decimalSeparator={','}
                valueIsNumericString
                prefix="R$"
            />
        );
    },
);


export const DetalheDeDispensaHistorico: React.FC = () => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    const { id = 'nova' } = useParams<"id">();
    const { formRef, save } = useVForm();
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { logout } = useAuthContext();
    //const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstFranquiaDrop, setLstFranquiaDrop] = useState<ILstDrop[]>([]);
    const [lstFranquia, setLstFranquia] = useState<IDetalheFranquia[]>([]);
    const [lstTodosJogadores, setLstTodosJogadores] = useState<IListagemJogador[]>([]);

    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);

    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoImage, setLogoImage] = useState("");
    const [observacao, setObservacao] = useState("");
    const [valorMulta, setValorMulta] = useState("");
    const [valorSalario, setValorSalario] = useState("");
    const [data, setData] = useState("");
    const [qtdFranquias, setQtdFranquias] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [franquiaRecebe, setFranquiaRecebe] = useState(0);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [quantidadeAnos, setQuantidadeAnos] = useState(0);
    const [codigoJogador, setCodigoJogador] = useState(0);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([])
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [dadosObservacao, setDadosObservacao] = useState<string[]>([]);
    const [lstTiposAtivosProposta, setLstTiposAtivosProposta] = useState<any[]>([]);
    const [idEdicao, setIdEdicao] = useState(0);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });
    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: " ",
        display: "none",
        titulo: "Atenção"
    });

    const options: Intl.NumberFormatOptions = { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }
    const formatNumber = new Intl.NumberFormat('pt-BR', options);

    useEffect(() => {
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRedirecionar(`/usuario/liga/${codLocal}`);
            return;
        }
        else {
            handleCarregarJogadores(true);
            handleCarregarTemporadas();
            LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const liga = result.dado;
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setLogoImage(liga.caminho_Logo);
                    setQtdFranquias(liga.quantidade_Franquia);
                    //setCodigoTemporada(liga.codigo_Temporada);

                    if (liga.abertura_Mercado !== true) {
                        navigate(0);
                        return;
                    }
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

            setIsLoading(true);

            const fetchData = async () => {
                await FranquiaService.getByIdLiga(Number(codigoLiga))
                    .then((result) => {
                        setLstFranquia(result.dado);
                        let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome, outros: f.caminho_Logo, descricao: f.nome_Usuario }));
                        setLstFranquiaDrop(lstFranquia);

                    })
                    .catch((errors) => {
                        setRemoveLoading(true);
                        setShowModalMensagem(true);
                        if (errors.response.data.statusHTTP === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        else {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                    });

                setRemoveLoading(true);
                setIsLoading(false);
            }
            fetchData();
        }
    }, [codigoLiga, id]);

    const handleCarregarTemporadas = async () => {
        await UtilidadeService.getTemporadas(true, 0)
            .then((result) => {
                setIsLoading(false);
                const tmps = result.data.dado;
                let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));

                setLstTemporadas(lstTemporadasAux);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const handleCarregarJogadores = async (atualizarAutoComplete: boolean) => {
        await JogadorService.getTodosJogadores(Number(codigoLiga),0,0,0,"",0)
            .then((result) => {
                setIsLoading(false);
                setLstTodosJogadores(result.data.dado);
                const lstDrop: TDropOptions[] = result.data.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                if (atualizarAutoComplete === true)
                    setOpcoesAutoCompleteJogador(lstDrop);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    // const carregarInformacoes = async (id: any) => {
    //     const resultCrypt = UtilidadeService.decrypt(id);
    //     if (resultCrypt === "" || resultCrypt === undefined) {
    //         setShowModalMensagem(true);
    //         setRemoveLoading(true);
    //         setIsLoading(false);

    //         setDadosModal({
    //             acao: true,
    //             label: "",
    //             tipo: "info",
    //             mensagem: "Dados inválidos! ",
    //             display: "none",
    //             titulo: "Atenção"
    //         });
    //         setRedirecionar(`/usuario/liga/${codLocal}`);
    //         return;

    //     }
    //     let decrpt = resultCrypt !== undefined ? resultCrypt?.split("|") : [];
    //     setFranquiaEnvia(Number(decrpt[1]))
    //     setIdEdicao(Number(decrpt[0]));
    //     await PropostaService.getPorCodigo(Number(decrpt[0]))
    //         .then((result) => {
    //             let dadosProposta = result.dado;
    //             let lstItensPropostas = dadosProposta.dados_Proposta;
    //             dadosProposta.franquias.forEach(f => {

    //                 let obj = {
    //                     codigo: f.codigo_Proposta,
    //                     logo_Franquia_Envia: f.logo,
    //                     logo_Franquia_Recebe: f.logo,
    //                     codigo_Franquia_Envia: f.codigo,
    //                     codigo_Franquia_Recebe: f.codigo,
    //                     nome_Franquia_Envia: f.nome,
    //                     nome_General_Manager_Envia: f.nome_General_Manager,
    //                     nome_Franquia_Recebe: f.nome,
    //                     nome_General_Manager_Recebe: f.nome_General_Manager,
    //                     situacao: f.situacao,
    //                     //logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //                     //codigo_Franquia_Recebe: franquiaRecebe,
    //                     //nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //                     //nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //                     dados_Propostas: lstItensPropostas
    //                 }
    //                 lstDadosPropostaCabecalho.push(obj);
    //             });

    //             // dadosProposta.franquias.forEach(f => {
    //             //     let obj = {
    //             //         codigo: f.codigo_Proposta,
    //             //         logo_Franquia_Recebe: f.logo,
    //             //         codigo_Franquia_Recebe: f.codigo,
    //             //         nome_Franquia_Recebe: f.nome,
    //             //         nome_General_Manager_Recebe: f.nome_General_Manager,
    //             //         situacao: f.situacao,
    //             //         //logo_Franquia_Recebe: fraquiaEnvolvidaRecebe?.outros,
    //             //         //codigo_Franquia_Recebe: franquiaRecebe,
    //             //         //nome_Franquia_Recebe: fraquiaEnvolvidaRecebe?.label,
    //             //         //nome_General_Manager_Recebe: fraquiaEnvolvidaRecebe?.descricao,
    //             //         dados_Propostas: lstItensPropostas
    //             //     }
    //             //     lstDadosPropostaCabecalhoRecebe.push(obj);
    //             //});
    //         })
    //         .catch((errors) => {
    //             setRemoveLoading(true);
    //             setShowModalMensagem(true);
    //             if (errors.response.data.statusHTTP === 401) {
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: "Sessão expirada!",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 logout();
    //                 setRedirecionar("0");
    //                 return;
    //             }
    //             if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "info",
    //                     mensagem: errors.response.data.mensagem,
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 setRedirecionar(`/usuario/liga/${codLocal}`);
    //                 return;
    //             }
    //             else {
    //                 setDadosModal({
    //                     acao: true,
    //                     label: "",
    //                     tipo: "error",
    //                     mensagem: "Não foi possível carregar os dados da proposta! Favor entrar em contato com a TI",
    //                     display: "none",
    //                     titulo: "Atenção"
    //                 });
    //                 setRedirecionar(`/usuario/liga/${codLocal}`);
    //                 return;
    //             }
    //         });

    // }

    const handleSave = async (dados: IDadosDispensaHistorico) => {
        setRemoveLoading(false);
        setIsLoading(true);
        setShowModalMensagem(false);
        setObservacao(JSON.stringify(dadosObservacao));

        if (codigoTemporada === undefined || codigoTemporada <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a temporada!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        if (data === undefined || data === "") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a data!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        if (codigoFranquia === undefined || codigoFranquia <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a franquia!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        if (quantidadeAnos === undefined || quantidadeAnos <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar a quantidade anos!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        if (selectedIdComplete === undefined || selectedIdComplete <= 0) {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o jogador!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }


        if (valorMulta === undefined || valorMulta === "") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o valor da multa!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }

        if (valorSalario === undefined || valorSalario === "") {
            setIsLoading(false);
            setRemoveLoading(true);
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Favor informar o valor do salário!",
                display: "none",
                titulo: "Atenção"
            });

            return;
        }


        dados = {
            ...dados,
            codigo_Franquia: codigoFranquia !== null ? codigoFranquia : 0,
            codigo_Temporada: codigoTemporada,
            codigo_Jogador: selectedIdComplete,
            data: data,
            salario: valorSalario,
            multa: valorMulta,
            codigo_Usuario: user.codUsuario,
            quantidade_Anos: quantidadeAnos,
        }

        if (idEdicao === 0) {
            FranquiaService.dispensarJogadorFranquiaHistorico(dados)
                .then((result) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Dispensa realizada com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    handleLimparCampos();
                    //setRedirecionar("0");
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    console.log(errors);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                        }
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível realizar a dispensa! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
    };

    const handleLimparCampos = () => {
        setCodigoTemporada(0);
        setData("");
        setCodigoFranquia(0);
        setQuantidadeAnos(0);
        setCodigoJogador(0);
        setValorSalario("");
        setValorMulta("");
        setSelectedIdComplete(0);
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(-1);
        }
    };


    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);

    }

    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);



    return (
        <LayoutBaseDePagina
            titulo={`Liga - ${nomeLiga}`}
            showLogoImg={logoImage}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoSalvarEFechar={false}
                    mostrarBotaoSalvar={true}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmVoltar={() => navigate("/liga/propostas/completa")}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container padding={2} spacing={2}>
                        <Grid container size={{ xs: 12, sm: 12 }} >
                            <Grid size={{ xs: 12, sm: 9, md: 9 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Criar Histórico Proposta</Typography>
                                <hr />
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={1}>
                            <Grid size={{ xs: 11, sm: 5, md: 5 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Temporada</InputLabel>
                                    <Select
                                        native={false}
                                        value={codigoTemporada}
                                        label="Temporada"
                                        defaultValue={0}
                                        onChange={(e) => { setCodigoTemporada(Number(e.target.value)); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }

                                    </Select>
                                </FormControl >
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    style={{ colorScheme: "auto" }}
                                    disabled={isLoading}
                                    label="Data Dispensa"
                                    value={data}
                                    onChange={(e) => setData(e.target.value)}
                                    slotProps={{
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={1}>
                            <Grid size={{ xs: 11, sm: 5, md: 5 }}  >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Franquia</InputLabel>
                                    <Select
                                        native={false}
                                        value={codigoFranquia}
                                        label="Franquia"
                                        defaultValue={0}
                                        onChange={(e) => { setCodigoFranquia(Number(e.target.value)); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        {
                                            lstFranquiaDrop.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                        }
                                    </Select>
                                </FormControl >
                            </Grid>

                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" spacing={1}>
                            <Grid size={{ xs: 12, sm: 6, md: 6 }} paddingBottom={2}>
                                <Autocomplete
                                    openText="Abrir"
                                    closeText="Fechar"
                                    noOptionsText="Sem opções"
                                    loadingText="Carregando..."
                                    options={opcoesAutoCompleteJogador}
                                    loading={isLoading}
                                    disabled={isLoading}
                                    value={autoCompleteSelectedOption}
                                    size={UtilidadeService.isMobile() ? "small" : "medium"}
                                    onChange={(event, newValue) => { setSelectedIdComplete(newValue?.codigo); }}
                                    popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Jogador"
                                            slotProps={{
                                                inputLabel: {
                                                    style: {
                                                        fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>                          
                        </Grid>
                        <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="start" spacing={1}>
                            <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                <TextField
                                    defaultValue={0}
                                    fullWidth
                                    type="text"
                                    label="Salário"
                                    value={valorSalario}
                                    onChange={(e) => { setValorSalario(e.target.value) }}
                                    slotProps={{
                                        input: {
                                            inputComponent: NumericFormatCustom as any,
                                        }
                                    }}
                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2, md: 2 }} >
                                <TextField
                                    defaultValue={0}
                                    fullWidth
                                    type="text"
                                    label="Valor Multa"
                                    value={valorMulta}
                                    onChange={(e) => { setValorMulta(e.target.value) }}
                                    slotProps={{
                                        input: {
                                            inputComponent: NumericFormatCustom as any,
                                        }
                                    }}
                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                />
                            </Grid>
                            <Grid size={{ xs: 6, sm: 2, md: 2 }} >
                                <FormControl fullWidth disabled={isLoading}>
                                    <InputLabel id="demo-simple-select-label">Quantidade Anos</InputLabel>
                                    <Select
                                        value={quantidadeAnos}
                                        label="Quantidade Anos"
                                        defaultValue={0}
                                        onChange={(e) => { setQuantidadeAnos(Number(e.target.value)); }}
                                        style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto", height: UtilidadeService.isMobile() ? 40 : "auto" }}
                                    >
                                        <MenuItem value={0}>Selecione</MenuItem>
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        {!removeLoading && <Loading />}
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    )
};

